import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAuth } from "@angular/fire/compat/auth";
import firebase from 'firebase/compat/app';
import 'firebase/auth';
import { AuthService } from 'src/app/providers/auth-service/auth-service';

@Component({
  selector: 'app-account-actions',
  templateUrl: './account-actions.page.html',
  styleUrls: ['./account-actions.page.scss'],
  host: {
    'class': 'accent-page'
  }
})
export class AccountActionsPage implements OnInit {


  mode: string = "resetPassword"; // resetPassword, recoverEmail, verifyEmail
  code: string = "";

  verifying: boolean = true;
  loading: boolean = false;

  error: string = "";
  success: string = "";

  newPassword: string = "";
  newPasswordRepeat: string = "";

  constructor(
    public afAuth: AngularFireAuth,
    public auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router
    ) {

  }

  ngOnInit(){
    this.activatedRoute.queryParams.subscribe(params => {
      this.mode = params['mode'];
      if( this.mode != "resetPassword"
        && this.mode != "recoverEmail"
        && this.mode != "verifyEmail"){
        this.mode = "";
      }
      this.code = params['oobCode'];

      if(this.mode){
        this.verifying = true;
        this.afAuth.checkActionCode(this.code).then(()=>{
          this.verifying = false;
          if(this.mode == "verifyEmail"){
            this.verifyEmail();
          }
        }).catch((err)=>{
          this.verifying = false;
          this.error = "Code invalid or expired. Please retry and click the link in a recent email.";
        });
      } else {
        this.verifying = false;
      }
    });
  }

  resetPassword(){
    this.loading = true;

    if(this.newPassword != this.newPasswordRepeat){
      this.loading = false;
      this.error = "Password and password confirm doesn't match.";
    } else {
      this.afAuth
      .confirmPasswordReset(this.code, this.newPassword)
      .then(() => this.router.navigate(['login']))
      .catch(err => {
        this.loading = false;
        this.error = this.firebaseErrorToText(err.code); // check this helper class at the bottom
      });
    }
  }

  verifyEmail(){
    this.loading = true;
    this.afAuth
    .applyActionCode(this.code)
    .then(() => {
      this.loading = false;
      this.success = "Email confirmed. ✔️";
    })
    .catch(err => {
      this.loading = false;
      this.error = this.firebaseErrorToText(err.code); // check this helper class at the bottom
    });
  }

  firebaseErrorToText(errorCode){
    let message = "";
    switch (errorCode) {
     case 'auth/wrong-password':
       message = 'Invalid login credentials.';
       break;
     case 'auth/network-request-failed':
       message = 'Please check your internet connection';
       break;
     case 'auth/too-many-requests':
       message =
         'We have detected too many requests from your device. Take a break please!';
       break;
     case 'auth/user-disabled':
       message =
         'Your account has been disabled or deleted. Please contact the system administrator.';
       break;
     case 'auth/requires-recent-login':
       message = 'Please login again and try again!';
       break;
     case 'auth/email-already-exists':
       message = 'Email address is already in use by an existing user.';
       break;
     case 'auth/user-not-found':
       message =
         'We could not find user account associated with the email address or phone number.';
       break;
     case 'auth/phone-number-already-exists':
       message = 'The phone number is already in use by an existing user.';
       break;
     case 'auth/invalid-phone-number':
       message = 'The phone number is not a valid phone number!';
       break;
     case 'auth/invalid-email  ':
       message = 'The email address is not a valid email address!';
       break;
     case 'auth/cannot-delete-own-user-account':
       message = 'You cannot delete your own user account.';
       break;
      default:
       message = 'Oops! Something went wrong. Try again later.';
       break;
   }
   return message;
  }

  logout(){
    this.auth.logout();
    // @ts-ignore
    window.location.href = '/login?mode=logout';
  }

}
